import {
  Button,
  ButtonGroup,
  H2,
  Modal,
  TextInput,
} from "@datapay-by-datacom/design-system";
import { useState } from "react";
import { Org } from "../../../generated/core-api";
import styles from "./OrgSettings.module.css";

interface OrgDeprovisionModalProps {
  org: Org;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (verificationText: string) => void;
  isPending: boolean;
}

export function OrgDeprovisionModal({
  org,
  isOpen,
  onClose,
  onConfirm,
  isPending,
}: OrgDeprovisionModalProps) {
  const [verificationText, setVerificationText] = useState("");

  const isVerificationValid =
    verificationText === org.id || verificationText === org.name;

  const handleInputChange = (value: string) => {
    setVerificationText(value);
  };

  const handleConfirm = () => {
    onConfirm(verificationText);
    setVerificationText("");
  };

  return (
    <Modal isOpen={isOpen}>
      <div className={styles.deprovisionModal}>
        <H2>{`Deprovision ${org.name}`}</H2>

        <p>
          This action will permanently deprovision this organization and all its
          resources. This cannot be undone.
        </p>

        <p>
          <strong>
            To confirm, please enter the organization name or ID: {org.name} or{" "}
            {org.id}
          </strong>
        </p>

        <TextInput
          value={verificationText}
          onChange={handleInputChange}
          placeholder="Enter organization name or ID to confirm"
        />

        <ButtonGroup>
          <Button variant="tertiary" onPress={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onPress={handleConfirm}
            isDisabled={!isVerificationValid || isPending}
          >
            {isPending ? "Deprovisioning..." : "Deprovision"}
          </Button>
        </ButtonGroup>
      </div>
    </Modal>
  );
}
